(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collections"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.currentScript.closest('.bfg-six-banners');
    if (!root) return;
    var scroller = root.querySelector('.custom-collection-section');
    if (!scroller) return;
    scroller.addEventListener('wheel', function(e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        scroller.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
